import { render, staticRenderFns } from "./qr-card.vue?vue&type=template&id=cc2678da&scoped=true"
import script from "./qr-card.vue?vue&type=script&lang=js"
export * from "./qr-card.vue?vue&type=script&lang=js"
import style0 from "./qr-card.vue?vue&type=style&index=0&id=cc2678da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2678da",
  null
  
)

export default component.exports